export default [
  {
    path: '/app/cache-params',
    name: 'CacheParams',
    component: () => import('@/views/Admin/Cache_params/Index.vue'),
    meta: {
      pageTitle: 'Ayarlar',
      breadcrumb: [
        {
          text: 'Önbellek Kontrolü',
          active: true,
        },
      ],
      resource: 'ADMIN_CONFIGS',
      action: 'read',
    },
  },
]
